import useGetUser from './useGetUser';

export * from './useGetUser';
export default useGetUser;
